/**
 * [TD-47.2b + TD-47.3] DraftFiltersContext - light filter + cross-pane
 * state broker for the unified draft shell. Mirrors the AuthContext /
 * ThemeContext / DraftContext additive-provider pattern.
 *
 * v1.2-TD-47.2b: brokered `posFilter` (RosterPanel YOU NEED chips publish
 *                → PlayerPoolWithDrawer consumes).
 *
 * v1.2-TD-47.3 (Gap 3 verdict A): adds `selectedPlayerId` /
 *                `setSelectedPlayerId` so SnakeCenterSurface's Top-of-Queue
 *                card can pre-fill the SnakePlayerPool drawer (cross-pane
 *                hand-off without lifting state into SnakeDraftContext).
 *
 * Defaults: `posFilter = "ALL"`, `selectedPlayerId = null`.
 * Setter `setPosFilter` accepts canonical position codes; FLEX/null coerce
 * to "ALL".
 */
import { createContext, useContext, useState, useCallback } from "react";

const DraftFiltersContext = createContext({
  posFilter: "ALL",
  setPosFilter: () => {},
  selectedPlayerId: null,
  setSelectedPlayerId: () => {},
});

export function DraftFiltersProvider({ children }) {
  const [posFilter, setPosFilterRaw] = useState("ALL");
  const [selectedPlayerId, setSelectedPlayerIdRaw] = useState(null);

  const setPosFilter = useCallback((pos) => {
    // Defensive - coerce nulls/undefined back to ALL so consumers never read
    // a falsy filter value.
    setPosFilterRaw(pos || "ALL");
  }, []);

  const setSelectedPlayerId = useCallback((id) => {
    setSelectedPlayerIdRaw(id || null);
  }, []);

  return (
    <DraftFiltersContext.Provider
      value={{ posFilter, setPosFilter, selectedPlayerId, setSelectedPlayerId }}
    >
      {children}
    </DraftFiltersContext.Provider>
  );
}

export const useDraftFilters = () => useContext(DraftFiltersContext);

// Test-only escape hatch: lets tests render consumers without a Provider.
// Returns the safe default identity exposed at module load.
export const __DEFAULT_DRAFT_FILTERS__ = {
  posFilter: "ALL",
  setPosFilter: () => {},
  selectedPlayerId: null,
  setSelectedPlayerId: () => {},
};
